import Repository from '../repository';

const resource = '/auth';

export default {
  login(credentials) {
    return Repository.post(`${resource}/login`, credentials);
  },
  register(user) {
    return Repository.post(`${resource}/register`, user);
  },
  logout() {
    return Repository.post(`${resource}/logout`);
  },
  reset_password(credentials) {
    return Repository.post(`${resource}/reset-password`, credentials);
  },
  update_password(credentials) {
    return Repository.post(`${resource}/update-password`, credentials);
  },
  loginWithSocial(provider, params = {}) {
    return Repository.get(`${resource}/${provider}/authenticate`, { params });
  },
};
